<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav hidden-xs hidden-sm hidden-md">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/drawing/logo4.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper" ref="navboxref" id="navboxref">
        <li
          v-for="(item,index) in navList"
          :key="item.id"
          class="nav-item-box"
          :class="item.id==navIndex?'active':''"
          @click="navClick(item.id,item.name)"
        >
          <router-link :to="item.path" v-if="item.path != 0" :class="langvalue == 'en'?'ssstyle':''">
            {{item.name}}
          </router-link>
          <span v-else :class="langvalue == 'en'?'ssstyle':''">
            {{item.name}}
          </span>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path" :class="langvalue == 'en'?'ssstyle':''">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
      <!-- 中英文 -->
      <div class="language-css">
        <languageSwitch langu="1"></languageSwitch>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs visible-sm visible-md">
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        <div class="header-nav-m-logo">
          <img class="center-block" src="@/assets/img/drawing/logo.png" alt="logo">
        </div>
        <div>{{menuName}}</div>
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in phoneNavList"
            :key="item.id"
            :class="item.id==navIndex?'active':''"
            @click="navClick(item.id,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{item.name}}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import languageSwitch from '@/components/languageSwitch'
export default {
  name: "Header",
  components:{languageSwitch},
  data() {
    return {
      navIndex:0,
      langvalue:"",
      menuName: this.$t('homePage'),
      menuClass: "glyphicon glyphicon-menu-hamburger",
      navList: [
        {
          name: this.$t('homePage'),
          path: "/",
          children: [],
          id:0,
        },
        {
          //name: "玉泉山",
          name: this.$t('jadeFountainHill'),
          path: "/service",
          children: [],
          id:1,
        },
        {
          name: this.$t('guanLing'),
          id:2,
          path: "/guanling",
          children: []
        },
        {
          name: this.$t('recentNews'),
          id:3,
          path: "/recentnews",
          children: []
        },
        {
          name: this.$t('playGuide'),
          id:4,
          path: "/playguide",
          children: []
        },
        {
          name: this.$t('smartTourism'),
          id:5,
          path: "0",
          children: [
            /*{
              name: this.$t('forgame'),
              id:6,
              path: "/software/smartTown"
            },*/
            {
              name: this.$t('oneClickReservation'),
              id:7,
              path: "/oneClickReserve"
            },
            {
              name: this.$t('oneKeyNavigation'),
              id:8,
              path: "/oneClickNavigation"
            },
            {
              name: this.$t('messageInteraction'),
              id:9,
              path: "/MessageBoard"
            },
            {
              name: '云游景区',
              id:9,
              path: "/MessageBoard"
            }
          ]
        },
        {
          name: this.$t('yuquanCulturalTravel'),
          id:10,
          path: "0",
          children: [
            {
              name:  this.$t('companyProfile'),
              id:11,
              path: "/companyintroduction"
            },
            {
              name: this.$t('businessCooperation'),
              id:12,
              path: "/businessCooperation"
            },
            {
              name: this.$t('talentWanted'),
              id:13,
              path: "/talentWanted"
            },
            {
              name: this.$t('contactUs'),
              id:14,
              path: "/callus"
            }
          ]
        },
      ],
      phoneNavList:[
        {
          name: this.$t('homePage'),
          path: "/",
          children: [],
          id:0,
        },
        {
          //name: "玉泉山",
          name: this.$t('jadeFountainHill'),
          path: "/service",
          children: [],
          id:1,
        },
        {
          name: this.$t('guanLing'),
          id:2,
          path: "/guanling",
          children: []
        },
        {
          name: this.$t('recentNews'),
          id:3,
          path: "/recentnews",
          children: []
        },
        {
          name: this.$t('playGuide'),
          id:4,
          path: "/playguide",
          children: []
        },
        /*{
              name: this.$t('forgame'),
              id:6,
              path: "/software/smartTown"
            },*/
        {
          name: this.$t('oneClickReservation'),
          id:7,
          path: "/oneClickReserve"
        },
        {
          name: this.$t('oneKeyNavigation'),
          id:8,
          path: "/oneClickNavigation"
        },
        {
          name: this.$t('messageInteraction'),
          id:9,
          path: "/MessageBoard"
        },
        {
          name:  this.$t('companyProfile'),
          id:11,
          path: "/companyintroduction"
        },
        {
          name: this.$t('businessCooperation'),
          id:12,
          path: "/businessCooperation"
        },
        {
          name: this.$t('talentWanted'),
          id:13,
          path: "/talentWanted"
        },
        {
          name: this.$t('contactUs'),
          id:14,
          path: "/callus"
        }
      ]
    };
  },
  watch:{
    $route:{
      handler(val,oldval){
        this.navIndex = sessionStorage.getItem('navIndex');
      },
      // 深度观察监听
      deep: true
    }
  },
  mounted() {
    this.langvalue = window.localStorage.getItem('locale')
  },
  methods: {
    navClick(id, name) {
      this.navIndex = id;
      sessionStorage.setItem('navIndex',id)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-hamburger") {
        this.menuClass = "glyphicon glyphicon-menu-hamburger";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-hamburger";
      }
    }
  }
};
</script>
<style src="@/assets/css/header.css"></style>



// WEBPACK FOOTER //
// src/components/Header.vue